import { Paper, Box, Chip, IconButton, Button } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 65px);
  background-color: var(--mui-palette-background-default);
  overflow: hidden;
  box-sizing: border-box;
`;

export const FrameContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
  background-color: var(--mui-palette-background-paper);
`;

export const DatePickerWrapper = styled(Box)`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

export const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--mui-palette-divider);
  z-index: 10;
`;

export const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

export const ToolbarRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 65px);
  overflow: hidden;
  position: relative;
`;

export const MainContent = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto;
  z-index: 1;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const ChartContainer = styled(Paper)`
  box-sizing: border-box;
  position: relative;
  height: 400px;
  box-shadow: none !important;
`;

export const TableContainer = styled(Paper)`
  margin-bottom: 16px;
`;

export const CalendarContainer = styled(Paper)`
  margin-bottom: 16px;
  padding: 16px;
  box-sizing: border-box;
  position: relative;
  height: calc(100vh - 200px);
  overflow: hidden;

  .fc {
    height: 100%;
  }

  .fc-event {
    cursor: pointer;
  }

  .fc-day-today {
    background-color: rgba(25, 118, 210, 0.05) !important;
  }

  .fc-daygrid-day-number {
    font-weight: 500;
  }

  .production-event {
    background-color: #1890ff;
    border-color: #1890ff;
  }

  .input-event {
    background-color: #52c41a;
    border-color: #52c41a;
  }

  .output-event {
    background-color: #fa8c16;
    border-color: #fa8c16;
  }

  .fc-h-event .fc-event-title {
    font-weight: 500;
  }

  .fc-day-sat .fc-daygrid-day-number {
    color: #0066cc;
  }

  .fc-day-sun .fc-daygrid-day-number {
    color: #e91e63;
  }
`;

export const ItemSelectionPanel = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 320px;
  height: 100%;
  z-index: 10;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  transform: translateX(${(props) => (props.$isOpen ? "0" : "100%")});
  transition: transform 0.3s ease-in-out;
`;

export const DateSelectionPanel = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(-50%)
    translateY(${(props) => (props.$isOpen ? "0" : "-103%")});
  width: 420px;
  z-index: 10;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 0 0 8px 8px;
  transition: transform 0.3s ease-in-out;
`;

export const PanelHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid var(--mui-palette-divider);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f5f5;
`;

export const PanelContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 96, 150, 0.7);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const CategoryContainer = styled(Box)`
  margin-bottom: 12px;
`;

export const CategoryHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.03);
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.06);
  }
`;

export const ItemList = styled(Box)`
  padding: 6px 12px 6px 24px;
`;

export const SelectedItemsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid var(--mui-palette-divider);
  background-color: rgba(0, 0, 0, 0.02);
  min-height: 48px;
  margin-bottom: 16px;
`;

export const StyledChip = styled(Chip)`
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const ControlsContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 16px;
`;

export const DateRangeContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
`;

export const LegendItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LegendColor = styled(Box)`
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background-color: ${(props) => props.color};
`;

export const SelectedItemsPreview = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 16px;
  padding: 4px 8px 4px 12px;
  background-color: #1976d2;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
`;

export const ToolbarIconButton = styled(IconButton)`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%) scaleX(${(props) => (props.$active ? 1 : 0)});
    height: 2px;
    width: 70%;
    background-color: #1976d2;
    transition: transform 0.2s ease;
    border-radius: 1px;
  }
`;

export const DateRangeDisplay = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 16px;
  background-color: #7c78bf;
  color: #fff;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
`;

export const DatePickerContainer = styled(Box)`
  padding: 8px 16px 16px;
  border-radius: 8px;
  background-color: #fff;
`;

export const PresetButtonGroup = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const PresetButton = styled(Button)`
  flex: 1;
  min-width: 90px;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 64px);
  background: #fff;
  position: relative;
  overflow: hidden;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  height: calc(100% - 120px);
  overflow: auto;
  padding: 1rem;
`;

export const DimOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const DimContent = styled(Box)`
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  text-align: center;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
`;
